import { IQueryOptions } from '../models/query';

export default function isQueryOptionsObject(options: IQueryOptions) {
	return options && typeof options === 'object' && options.queryOptionsType !== undefined;
}